// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
/**
 * Created by 不动的推动者 on 2018/5/2.
 */
//
import Vue from 'vue'
import App from './App'
import router from './router'

// 引入jQuery
import $ from 'jquery'
// 引用bootstrap
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min.js'
import 'babel-polyfill'

import {
	i18n
} from './i18n/index' //国际化

Vue.config.productionTip = false;
// if (!Array.prototype.find) {
//   Array.prototype.find = function(callback) {
//     return callback && (this.filter(callback) || [])[0];
//   };
// }
/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	i18n, //使用国际化
	components: {
		App
	},
	template: '<App/>'
});



//兼容classList（ie9）
if (!('classList' in document.documentElement)) {

	Object.defineProperty(HTMLElement.prototype, 'classList', {

		get: function() {

			var self = this;

			function update(fn) {

				return function(value) {

					var classes = self.className.split(/\s+/g);

					var index = classes.indexOf(value);

					fn(classes, index, value);

					self.className = classes.join(' ');

				};

			}

			return {

				add: update(function(classes, index, value) {

					if (!~index) classes.push(value);

				}),

				remove: update(function(classes, index) {

					if (~index) classes.splice(index, 1);

				}),

				toggle: update(function(classes, index, value) {

					if (~index) {
						classes.splice(index, 1);
					} else {
						classes.push(value);
					}

				}),

				contains: function(value) {

					return !!~self.className.split(/\s+/g).indexOf(value);

				},

				item: function(i) {

					return self.className.split(/\s+/g)[i] || null;

				},

			};

		},

	});

}



// WEBPACK FOOTER //
// ./src/main.js